import Vue from 'vue'
import Router from 'vue-router'
import router from '../assets/js/router'

Vue.use(Router)

export default new Router({
  routes: router
})



// WEBPACK FOOTER //
// ./src/router/index.js